import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-auction-vehicle-card',
  templateUrl: './auction-vehicle-card.component.html',
  styleUrls: ['./auction-vehicle-card.component.scss'],
})
export class AuctionVehicleCardComponent implements OnInit {
  @Input() vehicleImage: string;
  @Input() vehicleName: string;
  @Input() vehicleId: string;

  constructor() {}

  ngOnInit(): void {}
}
